import React, { useState, useEffect, useRef } from "react";
import { AppBar, Box, IconButton, Container, Toolbar } from "@mui/material";
import { Link } from "react-router-dom";
import tellwellLogo from "../../images/tellwell-blue-logo.png";
import tellwellbanner from "../../images/bookshelf-banner.png";
import tellwellbannermobile from "../../images/bookshelf-mobile-banner.png";
import "../../styles/main.scss";
import { styled } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import Collapse from "@mui/material/Collapse";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const Header: React.FC = () => {
  const [externalLink] = useState("https://tellwellpublishing.com");

  const DesktopMenuWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 990px)': {
      display: 'none', // Hide on small screens
    },
  }));

  const MobileMenuWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    '@media (min-width: 990px)': {
      display: 'none',
    },
    marginLeft: 'auto',
  }));

const theme = useTheme();
const isMobile = useMediaQuery(theme.breakpoints.down("md"));

useEffect(() => {
  if (!isMobile) {
    setMobileMenuOpen(false);
  }
}, [isMobile]);

  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const toggleDropdown = (name: string) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };

const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
const toggleMobileMenu = () => setMobileMenuOpen((prev) => !prev);


  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };


    const appBarRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!appBarRef.current) return;

      if (window.scrollY > 0) {
        appBarRef.current.classList.add("scrolled");
        alert("Scrolled!"); // test alert
      } else {
        appBarRef.current.classList.remove("scrolled");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Box sx={{ flexGrow: 1}}>
      <AppBar sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, boxShadow: "0 2px 5px #6c757d73"}} ref={appBarRef}>
        <Container maxWidth={false} className="desktopNavContainer">
          <Toolbar className="desktopNavbarDiv">
            <Link to="/" style={{ textDecoration: "none", color: "#ffffff" }}>
              <img src={tellwellLogo} className="tellwellLogo" alt="Tellwell Logo" />
            </Link>
            {/* Navigation List */}
            <DesktopMenuWrapper>
              <Box component="nav">
                <ul className="nav-menu">
                  <li><Link to="/">HOME</Link></li>

                  <li className="dropdown">
                    <Link to={`${externalLink}/packages`}>PACKAGES ▾</Link>
                    <ul className="dropdownMenu">
                      <li>
                        <a href={`${externalLink}/children-publishing`} target="_blank" rel="noopener noreferrer">
                          CHILDREN'S PUBLISHING
                        </a>
                      </li>
                      <li>
                        <a href={`${externalLink}/packages`} target="_blank" rel="noopener noreferrer">
                          REGULAR PUBLISHING
                        </a>
                      </li>
                      <li>
                        <a href={`${externalLink}/packages/premium-nonfiction`} target="_blank" rel="noopener noreferrer">
                          PREMIUM NONFICTION PACKAGES
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="dropdown">
                    <Link to="#">SERVICES ▾</Link>
                    <ul className="dropdownMenu">
                      <li>
                        <a href={`${externalLink}/services/audiobooks`} target="_blank" rel="noopener noreferrer">AUDIOBOOKS</a>
                      </li>
                      <li>
                        <a href={`${externalLink}/services/book-coaching/`} target="_blank" rel="noopener noreferrer">BOOK COACHING</a>
                      </li>
                      <li>
                        <a href={`${externalLink}/services/design`} target="_blank" rel="noopener noreferrer">DESIGN</a>
                      </li>
                      <li>
                        <a href={`${externalLink}/services/distribution`} target="_blank" rel="noopener noreferrer">DISTRIBUTION</a>
                      </li>
                      <li>
                        <a href={`${externalLink}/services/editing`} target="_blank" rel="noopener noreferrer">EDITING</a>
                      </li>
                      <li>
                        <a href={`${externalLink}/services/illustrations`} target="_blank" rel="noopener noreferrer">ILLUSTRATIONS</a>
                      </li>
                      <li>
                        <a href={`${externalLink}/services/marketing-publicity`} target="_blank" rel="noopener noreferrer">MARKETING & PUBLICITY</a>
                      </li>
                      <li>
                        <a href={`${externalLink}/us/services/premium-nonfiction/`} target="_blank" rel="noopener noreferrer">PREMIUM NONFICTION SERVICES</a>
                      </li>
                      <li>
                        <a href={`${externalLink}/services/printing`} target="_blank" rel="noopener noreferrer">PRINTING</a>
                      </li>
                    </ul>
                  </li>

                  <li><Link to={`${externalLink}/our-books`} target="_blank" rel="noopener noreferrer">OUR BOOKS</Link></li>
                  <li><Link to={`${externalLink}/testimonials`} target="_blank" rel="noopener noreferrer">TESTIMONIALS</Link></li>
                  <li><Link to={`${externalLink}/about-us`} target="_blank" rel="noopener noreferrer">ABOUT US</Link></li>
                  <li><Link to={`${externalLink}/contact-us`} target="_blank" rel="noopener noreferrer">CONTACT US</Link></li>
                  <li><a href="https://portal.tellwell.ca/" target="_blank" rel="noopener noreferrer">LOGIN</a></li>
                  <li><a href="https://publish.tellwellpublishing.com/quote/" className="quoteBtn" target="_blank" rel="noopener noreferrer">GET A QUOTE</a></li>
                </ul>
              </Box>
            </DesktopMenuWrapper>
<MobileMenuWrapper>
  <IconButton
    size="large"
    edge="start"
    color="inherit"
    aria-label="menu"
    onClick={toggleMobileMenu}
  >
    <MenuIcon />
  </IconButton>
</MobileMenuWrapper>
          </Toolbar>
        </Container>
      </AppBar>

      {/* Mobile Dropdown Navbar */}
<Collapse in={mobileMenuOpen} timeout="auto" unmountOnExit>
        <Box
          sx={{
            position: "absolute",
            top: "64px", // height of your AppBar
            left: 0,
            width: "100%",
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            zIndex: 1200,
            padding: "1rem",
          }}
        >
          <ul className="nav-menu-mobile">
            <li><Link to="/" onClick={closeMobileMenu}>HOME</Link></li>

            <li className="dropdown">
              <button onClick={() => toggleDropdown("packages")} className="dropdown-toggle">PACKAGES ▾</button>
             <Collapse in={openDropdown === "packages"} timeout="auto" unmountOnExit>
                <ul className="dropdownMenu">
                  <li>
                    <a href={`${externalLink}/children-publishing`} target="_blank" rel="noopener noreferrer">CHILDREN'S PUBLISHING</a>
                  </li>
                  <li>
                    <a href={`${externalLink}/packages`} target="_blank" rel="noopener noreferrer">REGULAR PUBLISHING</a>
                  </li>
                  <li>
                    <a href={`${externalLink}/packages/premium-nonfiction`} target="_blank" rel="noopener noreferrer">PREMIUM NONFICTION PACKAGES</a>
                  </li>
                </ul>
          </Collapse>
            </li>

            <li className="dropdown">
              <button onClick={() => toggleDropdown("services")} className="dropdown-toggle">SERVICES ▾</button>
            <Collapse in={openDropdown === "services"} timeout="auto" unmountOnExit>
                <ul className="dropdownMenu">
                  <li><a href={`${externalLink}/services/audiobooks`} target="_blank" rel="noopener noreferrer">AUDIOBOOKS</a></li>
                  <li><a href={`${externalLink}/services/book-coaching/`} target="_blank" rel="noopener noreferrer">BOOK COACHING</a></li>
                  <li><a href={`${externalLink}/services/design`} target="_blank" rel="noopener noreferrer">DESIGN</a></li>
                  <li><a href={`${externalLink}/services/distribution`} target="_blank" rel="noopener noreferrer">DISTRIBUTION</a></li>
                  <li><a href={`${externalLink}/services/editing`} target="_blank" rel="noopener noreferrer">EDITING</a></li>
                  <li><a href={`${externalLink}/services/illustrations`} target="_blank" rel="noopener noreferrer">ILLUSTRATIONS</a></li>
                  <li><a href={`${externalLink}/services/marketing-publicity`} target="_blank" rel="noopener noreferrer">MARKETING & PUBLICITY</a></li>
                  <li><a href={`${externalLink}/us/services/premium-nonfiction/`} target="_blank" rel="noopener noreferrer">PREMIUM NONFICTION SERVICES</a></li>
                  <li><a href={`${externalLink}/services/printing`} target="_blank" rel="noopener noreferrer">PRINTING</a></li>
                </ul>
      </Collapse>
            </li>

            <li><Link to={`${externalLink}/our-books`} target="_blank" rel="noopener noreferrer" onClick={closeMobileMenu}>OUR BOOKS</Link></li>
            <li><Link to={`${externalLink}/testimonials`} target="_blank" rel="noopener noreferrer" onClick={closeMobileMenu}>TESTIMONIALS</Link></li>
            <li><Link to={`${externalLink}/about-us`} target="_blank" rel="noopener noreferrer" onClick={closeMobileMenu}>ABOUT US</Link></li>
            <li><Link to={`${externalLink}/contact-us`} target="_blank" rel="noopener noreferrer" onClick={closeMobileMenu}>CONTACT US</Link></li>
            <li><a href="https://portal.ca/" target="_blank" rel="noopener noreferrer">LOGIN</a></li>
            <li><a href="https://publish.publishing.com/quote/" className="quoteBtn" target="_blank" rel="noopener noreferrer">GET A QUOTE</a></li>
          </ul>
        </Box>

</Collapse>

  <Box sx={{ mt: { sm: 10 }, '@media (max-width:650px)': { mt: '75px' } }}>
        {/* Desktop Banner */}
        <Box
          component="img"
          src={tellwellbanner}
          alt="Hero Banner"
          sx={{
            width: "100%",
            aspectRatio: "1521 / 220",
            height: { xs: "10vh", sm: "auto"},
            objectFit: "cover",
            display: { xs: "none", sm: "block" },
          }}
        />

        {/* Mobile Banner */}
        <Box
          component="img"
          src={tellwellbannermobile}
          alt="Hero Banner"
          sx={{
            width: "100%",
            aspectRatio: "160 / 23",
            height: "auto",
            objectFit: "cover",
            display: { xs: "block", sm: "none" },
          }}
        />
      </Box>
    </Box>
  );
};

export default Header;
